/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateNoteIndexPathParams, CandidateNoteIndexResponse } from '../types/CandidateNoteIndex'

/**
 * GET /candidates/:candidate/notes
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateNoteController.php CandidateNoteController::index
 */
export async function candidateNoteIndex(
	candidate: CandidateNoteIndexPathParams['candidate'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateNoteIndexResponse>> {
	return axiosInstance.get(`/candidates/${candidate}/notes`, config)
}
